import Preset from './_default';

export default class Brooklyn extends Preset {
    name = 'Narrative';

    // override the default Preset here
}
